import request from '@/utils/request';

/**
 * 本文件由code-generator根据yapi文档自动生成
 */

/**
 * 账号密码-登录
 */

export interface LoginParams {
  username: string;
  password: string;
}

export function login(data: LoginParams): Promise<any> {
  return request.post('/ai/iam/user/login', data);
}

export function getMenus(): Promise<any> {
  return request.get('/ai/business/app/getMenus');
}

export function getTenantList(): Promise<any> {
  return request.get('/ai/business/tenant/list');
}
